define(["dojo/i18n", "/home/semaphore/scramble4/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"scramble/widgets/builder/nls/zh-tw/selectShipViaModal"
,"scramble/widgets/builder/nls/zh/selectShipViaModal"
,"scramble/widgets/builder/nls/ja/selectShipViaModal"
,"scramble/widgets/builder/nls/fr/selectShipViaModal"
,"scramble/widgets/builder/nls/de/selectShipViaModal"
,"scramble/widgets/builder/nls/ko/selectShipViaModal"
,"scramble/widgets/builder/nls/it/selectShipViaModal"
,"scramble/widgets/builder/nls/cs/selectShipViaModal"
,"scramble/widgets/builder/nls/tr/selectShipViaModal"
,"scramble/widgets/builder/nls/pl/selectShipViaModal"
,"scramble/widgets/builder/nls/fi/selectShipViaModal"
,"scramble/widgets/builder/nls/hu/selectShipViaModal"
,"scramble/widgets/builder/nls/sk/selectShipViaModal"
,"scramble/widgets/builder/nls/nb/selectShipViaModal"
,"scramble/widgets/builder/nls/es/selectShipViaModal"
,"scramble/widgets/builder/nls/nl/selectShipViaModal"
,"scramble/widgets/builder/nls/pt/selectShipViaModal"
,"scramble/widgets/builder/nls/ru/selectShipViaModal"
,"scramble/widgets/builder/nls/sv/selectShipViaModal"
,"/home/semaphore/scramble4/src/scramble/widgets/builder/nls/selectShipViaModal.js?absMid=scramble/widgets/builder/nls/selectShipViaModal"
], function(loader, runner) {
   return runner(loader, "scramble/widgets/builder/nls/selectShipViaModal", __webpack_require__.dj.c(), false);
});